const key = (workflowId: string) => `workflow-branch:${workflowId}`;

export function rememberWorkflowBranch(workflowId: string, branchId: string) {
  localStorage.setItem(key(workflowId), branchId);
}

export function recallWorkflowBranch(workflowId: string): string | null {
  return localStorage.getItem(key(workflowId));
}

export function forgetWorkflowBranch(workflowId: string) {
  localStorage.removeItem(key(workflowId));
}
